import React from 'react';
import CardMiddle from '../../../../layouts/Client/CardMiddleItems'
import * as ROUTES from '../../../../routes';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SignInBtns from './Containers/SignInBtns'
import SignInEmail from './Containers/SignInEmail'



const SignInClient = (props) => {
  return (
    <>
      <CardMiddle
        mainTitle='Iniciar sesión'
        desFooter='¿Aún no tienes cuenta?'
        footerTitle='Regístrate'
        linkTo='/usuario-registro'
      >
        <Switch>
          <Route
            exact
            path={ROUTES.SIGN_IN_MAIN_CLIENT}
            component={SignInBtns}
          />
          <Route
            exact
            path={ROUTES.SIGN_IN_EMAIL_CLIENT}
            component={SignInEmail}
          />
          <SignInBtns />
        </Switch>
      </CardMiddle>
    </>
  );
}

export default SignInClient;